<template>
    <div class="login">
        <div class="container mt-5">
            <div class="ui segment pl-0 pr-0">
                <h3 class="ui header large-lg medium-md small black pt-2 pb-1 px-lg-5 px-md-3 px-2 mb-0 text-center">{{$t('SignIn')}} / {{$t('Register')}}
                    <div class="ui secondary pointing menu d-flex d-md-none mb-4 js-tab">
                        <router-link :to="'/login'" class="ui text medium item px-4 active ml-auto" data-tab="login">{{$t('SignIn')}}</router-link>
                        <router-link :to="'/register'" class="ui text medium item px-4 mr-auto" data-tab="register">{{$t('Register')}}</router-link>
                    </div>
                    <div class="position-relative">
                        <div class="row">
                            <div class="col-md-6 d-md-block ui tab active">
                                <form class="p-3">
                                    <!-- <h3 class="ui header semibold medium-lg small-md mini text-center color theme">{{$t('SignIn')}}</h3> -->
                                    <div class>
                                        <div class="ui labeled input col-12">
                                            <div class="ui basic label rounded-0">
                                                <div class="circular ui icon  button grey m-0 p-2"><i class="ui icon envelope open color white"></i></div>
                                            </div>
                                            <input v-model="login.email" class="ui input" type="text" :placeholder="$t('inEmail')">
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <div class="ui labeled input  col-12">
                                            <div class="ui basic label rounded-0">
                                                <div class="circular ui icon button grey m-0 p-2"><i class="ui icon lock color white"></i></div>
                                            </div>
                                            <input v-model="login.password" class="ui input" type="password" :placeholder="$t('inPassword')">
                                        </div>
                                    </div>
                                    <div class="text-right col-12 mt-3">
                                        <a class="ui text medium color gray-7 pointer" data-toggle="modal" data-target="#showModalForgot">
                                            <u>{{$t('ResetPass')}}</u>
                                        </a>
                                    </div>
                                    <div class="col-12">
                                        <button @click.prevent="$parent.loginFunction(login)" class="ui button theme text large col-12 mt-3 py-md-3 py-2">
                                            {{$t('SignIn')}}
                                        </button>
                                    </div>
                                    <div class="d-block col-12">
                                        <div class="ui horizontal divider">{{$t('OR')}}</div>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <button id="btnGoogle" @click.prevent="$parent.googleLogin" class="ui button text large col-12 py-md-3 py-2">
                                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 48 48" class="abcRioButtonSvg">
                                                            <g>
                                                                <rect x="0" y="0" rx="10" ry="10" width="48" height="48"
                                                                style="fill:#FFF;" />
                                                                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                                                                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                                                                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                                                                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                                                            </g>
                                                        </svg>
                                                    &nbsp; &nbsp; &nbsp;Google</button>
                                            </div>
                                            <div class="col-lg-6">
                                                <button @click.prevent="$parent.facebookLogin" id="loginbutton" class="ui button facebook text large col-12 py-md-3 py-2 mt-2 mt-lg-0">
                                                    <i class="facebook icon"></i> Facebook
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="col-md-6 d-md-block ui tab item" data-tab="register">
                                <div class="p-4">
                                    <h3 class="ui header semibold medium-lg small-md mini text-center color theme">{{$t('NewCustomer')}}</h3>
                                    <div class="row justify-content-center">
                                        <div class="col-4"><img class src="../assets/img/img-user.svg"></div>
                                    </div>
                                    <p class="ui text medium color gray-7 text-center mt-3">{{$t('TextRegister')}}</p>
                                    <router-link :to="'/register'" class="ui button teal text large col-12 mt-3 py-md-3 py-2">{{$t('Register')}}</router-link>
                                </div>
                            </div>
                        </div>
                        <div class="ui vertical divider d-none d-md-block">{{$t('OR')}}</div>
                    </div>
                </h3>
            </div>
        </div>
        <div class="modal fade" id="showModalForgot" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                        <div class="ui segment pl-0 pr-0">
                            <h2 class="ui header text-center mt-2 color theme">{{$t('ResetPass')}}</h2>
                            <div class="content">
                                <div class="col-12">
                                    <p class="text color gray-7 text-center">{{$t('MessageReset')}}</p>
                                </div>
                                <div class="mt-3">
                                    <div class="ui labeled input col-12">
                                        <div class="ui basic label">
                                            <div class="circular ui icon button grey m-0 p-2"><i class="ui icon envelope open color white"></i></div>
                                        </div>
                                        <input v-model="inputForgotEmail" type="text" :placeholder="$t('inEmail')">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <button @click="forgotEmail" :disabled="loading" class="ui button theme text large col-12 mt-3">{{$t('Send')}}</button>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'login',
    data() {
        return {
            showModalForgot: false,
            inputForgotEmail: '',
            login: {
                email: '',
                password: '',
            },
            message: {
                title: 'สมัครสมาชิก',
                message: ''
            },
            showMessage: false,
            loading: false,
        }
    },
    methods: {
        UIModal: function(){
            $(function () {
                $('.js-reset-password-modal').modal('show');
            })
        },
        forgotEmail(){
            this.loading = true
            this.$http
            .post('password/forgot',{email: this.inputForgotEmail})
            .then(response => {
                this.$parent.message.title = this.$t('ResetPass')
                this.$parent.message.message = this.$t('forgotSuccess')
                this.$parent.showMessage = !this.$parent.showMessage
                $('#showModalForgot').modal('hide');
            })
            .catch(error => {
                if(!error.response){
                    return
                }
                let message = error.response.data.errors.message
                let snakeCase = error.response.data.errors.snakeCase
                switch (snakeCase) {
                    case 'the_email_field_is_required.':
                        message = this.$t('rqEmail')
                        // error.response.data.errors
                        break;
                    case 'the_email_field_is_required.':
                        message = this.$t('rqEmail')
                        break;
                    case 'the_password_field_is_required.':
                        message = this.$t('rqPass')
                        break;
                    case 'the_password_must_be_at_least4_characters.':
                        message = this.$t('rqPassMin',{num: 4})
                        break;
                    case 'the_email_has_already_been_taken.':
                        message = this.$t('rqEmailUnique')
                        break;
                }
                this.$parent.message.title = this.$t('ResetPass')
                this.$parent.message.message = message
                this.$parent.showMessage = !this.$parent.showMessage
            })
            .finally(() => this.loading = false)
        },
        
    },
    created(){
        this.$parent.message.title = 'สมัครสมาชิก'
        localStorage.removeItem("_auth")
        localStorage.removeItem('accountType')
    },
    mounted() {

    }
}
</script>
<style lang="scss">
    .modal-dialog{
        top: 100px !important;
    }
    #btnGoogle{
        background-color: #4285f4;
        border: none;
        color: #fff;
        span{
            position: relative;
            background-color: #fff;
            width: 20px;
            height: 20px;
        }
    }
</style>